<template>
    <v-app>
        <router-view/>
        <left-menu v-if="displayMenu"></left-menu>
        <loading v-if="loading"></loading>
        <message-panel></message-panel>
    </v-app>
</template>

<script>
import LeftMenu from "./components/tools/LeftMenu"
import Loading from "./components/tools/Loading"
import MessagePanel from "./components/tools/MessagePanel"
import {mapState} from "vuex"

export default {
    name: "App",
    components: {MessagePanel, Loading, LeftMenu},
    data() {
        return {
            disabledRoutes: [
                "/accept-cgu",
                "/onboard",
                "/email-validation",
                "/web-form",
                "/preview",
                "/aura",
                "/espace-pro",
                "/simple-answer",
                "/cadh-preview",
                '/provider-data-diffs',
            ],
            disabledChatRoutes: ["/web-form", "/espace-pro", '/provider-data-diffs',],
        }
    },
    computed: {
        ...mapState("account", ["user"]),
        loading() {
            return this.$global.loading
        },
        displayMenu() {
            let enabled = true

            if (this.$route.path === "/") {
                return false
            }

            this.disabledRoutes.forEach((route) => {
                if (this.$route.path.includes(route)) {
                    enabled = false
                }
            })

            return enabled
        },
        intercomChatEnabled() {
            let enabled = true

            if (this.$route.path === "/") {
                return false
            }

            this.disabledChatRoutes.forEach((route) => {
                if (this.$route.path.includes(route)) {
                    enabled = false
                }
            })

            return enabled
        },
    },
    watch: {
        $route() {
            if (this.intercomChatEnabled) {
                window.Intercom("update")
            }
        },
    },
    mounted() {
        window.intercomSettings = {
            app_id: process.env.VUE_APP_INTERCOM_ID,
            alignment: "left",
            horizontal_padding: 70,
            vertical_padding: 30,
            platform: "HUBO",
        }

        if (this.user !== null) {
            let userConf = {
                user_id: this.user.id,
                name: this.user.first_name + " " + this.user.last_name,
                email: this.user.email,
                role: this.user.role.name,
                account_configured: this.user.account.configured,
            }

            Object.assign(window.intercomSettings, userConf)

            window.Intercom("update", window.intercomSettings)
        }

        window.Intercom("boot", window.intercomSettings)
    },
}
</script>
